import { render, staticRenderFns } from "./item-box.vue?vue&type=template&id=115501ec&"
import script from "./item-box.vue?vue&type=script&lang=ts&"
export * from "./item-box.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports